import { useCallback } from 'react';
import useCheckoutFormState from './useCheckoutFormState';

function useItemQuery() {
  const { state, dispatch } = useCheckoutFormState();

  const update = useCallback(
    (query: string) => {
      dispatch({ type: 'SET_QUERY', payload: query });
    },
    [dispatch],
  );

  return [state.query, update] as const;
}

export default useItemQuery;
